var _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveColourScale(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black_bez_okraje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled_section"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.43,9.83c-8.02,0-14.53,6.5-14.53,14.53s6.5,14.53,14.53,14.53c1.34,0,2.42-1.08,2.42-2.42,0-.63-.23-1.19-.63-1.62-.38-.43-.61-.98-.61-1.61,0-1.34,1.08-2.42,2.42-2.42h2.85c4.45,0,8.07-3.62,8.07-8.07,0-7.13-6.5-12.91-14.53-12.91ZM15.71,26.51c-1.85,0-3.34-1.49-3.34-3.34s1.49-3.34,3.34-3.34,3.34,1.49,3.34,3.34-1.49,3.34-3.34,3.34ZM21.17,18.13c-1.34,0-2.42-1.08-2.42-2.42s1.08-2.42,2.42-2.42,2.42,1.08,2.42,2.42-1.08,2.42-2.42,2.42ZM29.38,19.17c-1.34,0-2.42-1.08-2.42-2.42s1.08-2.42,2.42-2.42,2.42,1.08,2.42,2.42-1.08,2.42-2.42,2.42ZM33.29,25.31c-1.18,0-2.14-.96-2.14-2.14s.96-2.14,2.14-2.14,2.14.96,2.14,2.14-.96,2.14-2.14,2.14Z",
    fill: "none",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.76,26.97l1.33,1.67s-5.6,7.42-13.13,9.58c4.07-5.88,11.8-11.24,11.8-11.24Z",
    fill: "none",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.89,22.12s1.07,2.33.05,4.35c-1.45,2.87-3.85,2.17-3.85,2.17l-1.33-1.67s-.17-2.43,2.17-2.88c1.36-.26,2.96-1.98,2.96-1.98Z",
    fill: "#fbba00",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveColourScale);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-colour-scale.20ebaf053b65e6ee6471d0f85ac0dcb8.svg";
export { ForwardRef as ReactComponent };